import apiClient from "../apiClient";

const resource = "employeesCorrection";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    add: payload => apiClient.post(`${resource}`, payload),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
    approve: id => apiClient.put(`${resource}/${id}/approve`),
    reject: id => apiClient.put(`${resource}/${id}/reject`),
    //-------- Check --------------------------------//    
    getAdministrativeInfo: id => apiClient.get(`${resource}/${id}/administrativeInfo`),
    getEmployeeVacationsBalances: id => apiClient.get(`${resource}/${id}/employeeVacationsBalances`),

};